import { Injectable } from '@angular/core';
import { Comment } from '@app/models/comment';
import { CommentService } from '@app/services/api/comment.service';
import {
  AddMany,
  AddOne,
  CommentActionTypes,
  Create,
  CreateFail,
  CreateSuccess,
  LoadByProduct,
  LoadByProductFail,
  LoadByProductSuccess
} from '@core/actions/comment.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class CommentEffects {
  @Effect()
  loadByProduct$: Observable<Action> = this.actions$.pipe(
    ofType<LoadByProduct>(CommentActionTypes.LoadByProduct),
    map(action => action.productId),
    switchMap(productId => {
      return this.commentsApi.get('Product', productId).pipe(
        map((comments: Comment[]) => new LoadByProductSuccess(comments)),
        catchError(error => of(new LoadByProductFail(error)))
      );
    })
  );

  @Effect()
  loadSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<LoadByProductSuccess>(CommentActionTypes.LoadByProductSuccess),
    map(action => new AddMany(action.comments))
  );

  @Effect()
  create$: Observable<Action> = this.actions$.pipe(
    ofType<Create>(CommentActionTypes.Create),
    map(action => action.data),
    switchMap(data =>
      this.commentsApi.create(data).pipe(
        map((savedComment: Comment) => new CreateSuccess(savedComment)),
        catchError(error => of(new CreateFail(error)))
      )
    )
  );

  @Effect()
  createSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<CreateSuccess>(CommentActionTypes.CreateSuccess),
    map(action => {
      // this.fs.emit({ type: 'success', message: 'Comment creado' });
      return new AddOne(action.comment);
    })
  );

  constructor(private actions$: Actions, private commentsApi: CommentService) {}
}
